module.exports = __webpack_public_path__ + "catalog/items/lim/lim.png";